var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgBoxIcon = function SvgBoxIcon(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "currentColor",
    viewBox: "0 0 20 20",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.25 1.419a2.332 2.332 0 0 1 .666 4.564v8.032a2.333 2.333 0 0 1-.666 4.566 2.33 2.33 0 0 1-2.233-1.666H5.984a2.332 2.332 0 1 1-2.899-2.9V5.983a2.33 2.33 0 1 1 2.899-2.898h8.033a2.33 2.33 0 0 1 2.233-1.666M3.75 15.248a1.002 1.002 0 1 0 .002 2.005 1.002 1.002 0 0 0-.002-2.005m12.5 0a1.002 1.002 0 1 0 .001 2.005 1.002 1.002 0 0 0 0-2.005M5.985 4.415a2.33 2.33 0 0 1-1.57 1.568v8.032a2.34 2.34 0 0 1 1.57 1.57h8.031a2.34 2.34 0 0 1 1.57-1.57V5.983a2.33 2.33 0 0 1-1.57-1.568zM3.75 2.749a1.002 1.002 0 1 0 .001 2.005 1.002 1.002 0 0 0 0-2.005m12.5 0a1.002 1.002 0 1 0 .001 2.005 1.002 1.002 0 0 0 0-2.005"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgBoxIcon);
export default ForwardRef;